import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { style } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatSliderModule } from '@angular/material/slider';
import { of } from 'rxjs';


@Component({
  selector: 'app-musitedeep-prediction',
  templateUrl: './musitedeep-prediction.component.html',
  styleUrls: ['./musitedeep-prediction.component.css'],
})
export class MusitedeepPredictionComponent implements OnInit {
  // Hard-coded mock API response for testing
  private mockAPIResponse = {
    "querySeq": "ETGQSVNDPGNMSFVKETVDKLLKGYDIRLRPDFGGPP",
    "Results": [
      {
        "Position": "2",
        "PTMscores": "Phosphothreonine:0.61;O-linked_glycosylation:0.535",
        "Residue": "T"
      },
      {
        "Position": "5",
        "PTMscores": "Phosphoserine:0.819;O-linked_glycosylation:0.495",
        "Residue": "S"
      },
      {
        "Position": "13",
        "PTMscores": "Phosphoserine:0.781;O-linked_glycosylation:0.131",
        "Residue": "S"
      },
      {
        "Position": "18",
        "PTMscores": "Phosphothreonine:0.092;O-linked_glycosylation:0.073",
        "Residue": "T"
      }
    ]
  };
  
  // Flag to indicate whether to use mock data instead of real API call
  private useMockData = true; // Set to true for testing, false for production
  modeloptions = [
    'Phosphoserine_Phosphothreonine',
    'Phosphotyrosine',
    'N-linked_glycosylation',
    'O-linked_glycosylation',
    'Ubiquitination',
    'SUMOylation',
    'N6-acetyllysine',
    'Methylarginine',
    'Methyllysine',
    'Pyrrolidone_carboxylic_acid',
    'S-palmitoyl_cysteine',
    'Hydroxyproline',
    'Hydroxylysine',
  ];

  test = [
    // {name:"a", class:"highlight", index:""},
    // {name:'b', class:'none', index:""}
  ];
  positions;
  showResult = false;
  showWait = false;
  download_result;
  sliderValue: number = .5; 

  sequence;
  toppings = new FormControl({ value: 'Mushroom', disabled: false });
  toppingList: string[] = [
    'Extra cheese',
    'Mushroom',
    'Onion',
    'Pepperoni',
    'Sausage',
    'Tomato',
  ];

  constructor(private http: HttpClient, private router: Router) {
    // Initialize ELEMENT_DATA with a default empty structure
    this.ELEMENT_DATA = {
      name: [],
      display: [],
      data: [],
    };
  }
  ELEMENT_DATA;


  ngOnInit(): void {
    // Initialize with empty data structure
    this.ELEMENT_DATA = {
      name: [],
      display: [],
      data: [],
    };
  }

  fn_predictSeq() {
    this.test = [];
    let element = document.getElementById('seq') as HTMLInputElement;
    // console.log(element.value);
    if (element.value != '') {
      this.fetchInfo(element.value);
    } else {
      alert('Please input sequence!');
    }
  }

  fn_example() {
    // console.log('example');
    let element = document.getElementById('seq') as HTMLInputElement;
    element.value = 'ETGQSVNDPGNMSFVKETVDKLLKGYDIRLRPDFGGPP';
  }

  fetchInfo(seq) {
    // console.log('start');
    let model = this.modeloptions[0] + ';' + this.modeloptions[3];
    this.sequence = seq;
    
    this.showWait = true;
    this.showResult = false;

    // Use mock data or real API based on the flag
    if (this.useMockData) {
      // Simulate network delay with setTimeout for more realistic testing
      setTimeout(() => {
        this.showWait = false;
        this.showResult = true;
        
        try {
          // Use the hard-coded response
          console.log('Using mock API response data for testing');
          this.dealData(this.mockAPIResponse);
          this.download_result = this.mockAPIResponse;
        } catch (error) {
          console.error('Error processing mock data:', error);
          alert('Error processing prediction results. Please try again or contact support.');
          this.showResult = false;
          this.ELEMENT_DATA = {
            name: [],
            display: [],
            data: [],
          };
        }
      }, 500); // 500ms delay to simulate network request
    } else {
      // Real API call for production
      let url = '/api/musitedeep/' + model + '/' + seq;
      let headers = new HttpHeaders();

      const options: {
        headers?: HttpHeaders;
        observe?: 'body';
        params?: HttpParams;
        reportProgress?: boolean;
        responseType: 'json';
        withCredentials?: boolean;
      } = {
        responseType: 'json',
      };

      this.http.get(url, options).subscribe(
        (data: any) => {
          // console.log(data)
          this.showResult = true;
          this.showWait = false;
          
          try {
            this.dealData(data);
            this.download_result = data;
          } catch (error) {
            console.error('Error processing data:', error);
            alert('Error processing prediction results. Please try again or contact support.');
            this.showResult = false;
            this.ELEMENT_DATA = {
              name: [],
              display: [],
              data: [],
            };
          }
        },
        (error) => {
          console.error('API call error:', error);
          this.showWait = false;
          alert('Error making prediction. Please try again or contact support.');
          this.ELEMENT_DATA = {
            name: [],
            display: [],
            data: [],
          };
        }
      );
    }
  }

  fn_show3D() {
    //let url2 = "https://g2s.genomenexus.org/api/alignments/residueMapping?sequence="+this.sequence+"&positionList="+4;
    //let out = "";
    this.router.navigate([
      'show3dTable',
      {
        urlg2s:
          'https://g2s.genomenexus.org/api/alignments/residueMapping?sequence=' +
          this.sequence +
          '&positionList=' +
          this.positions,
      },
    ]);
    // window.open("https://www.musite.net/show3dtable/2021-03-22T21:24:55.826Zawbtab4v2wg2021-06-09T04:20:08.904Z")
  }

  fn_download() {
    let datastr =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(JSON.stringify(this.download_result));
    let downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute('href', datastr);
    downloadAnchorNode.setAttribute('download', 'Result.json');
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  dealData(data) {
    let ptm_index = 0;
    let ptmscore = 'PTMscores';
    // console.log(data.Results);
    let index_highLight = data.Results.map((element) => {
      return parseInt(element.Position) - 1;
    });
    let array_positions = data.Results.map((element) => {
      return element.Position;
    });
    this.positions = array_positions.toString();
    let array_seq = [...data.querySeq];
    // console.log(index_highLight);
    array_seq.forEach((element, index) => {
      // console.log('index: ', index);
      if (index_highLight.includes(index)) {
        this.test.push({
          name: element,
          class: 'highlight',
          index: String(index + 1),
          arrow: '|',
          tooltip: data.Results[ptm_index][ptmscore],
        });
        ptm_index++;
      } else {
        this.test.push({
          name: element,
          class: 'none',
          // index: (index + 1) % 10 == 0 ? String(index + 1) : '',
          index: '',
          // arrow: (index + 1) % 10 == 0 ? '|' : '',
          arrow: '',

          tooltip: '',
        });
      }
    });
    // console.log(this.test);
    // parse the data
    const parsedData = [];

    if (data.Results && Array.isArray(data.Results)) {
      data.Results.forEach(obj => {
        // parsing the 'PTMscores' element
        if (obj["PTMscores"] && obj["PTMscores"].includes(';')) {
          const splitValues = obj["PTMscores"].split(';');
          splitValues.forEach(value => {
            if (value.includes(':')) {
              const [modification_name, probability] = value.split(':');
              const newObj = { 
                ...obj, 
                modification_name: modification_name.trim(),
                probability: probability.trim()
              };
              parsedData.push(newObj);
            } else {
              parsedData.push(obj);
            }
          });
        } else if (obj["PTMscores"]) {
          // Handle single PTM score without semicolon
          const value = obj["PTMscores"];
          if (value.includes(':')) {
            const [modification_name, probability] = value.split(':');
            const newObj = {
              ...obj,
              modification_name: modification_name.trim(),
              probability: probability.trim()
            };
            parsedData.push(newObj);
          } else {
            parsedData.push(obj);
          }
        } else {
          // Fallback case
          parsedData.push(obj);
        }
      });
    } else {
      console.error('Invalid data format: Results is not an array', data);
    }

    // console.log(parsedData);

    this.ELEMENT_DATA = {
      name: ["Position", "Residue", "modification_name", "probability"],
      display: ["Position", "Amino Acid", "Modification Name", "Probability"],
      data: parsedData,
    };

  }

  fn_seqHighlight(item) {
    // console.log(item);
    let color = this.get_color_from_probability(item);
    let style = {
      'background-color': color, 
      'display' : 'inline-block',
      'width': '15px',
      'margin-left': '5px',
      'text-align': 'center', 
      'font-weight' : 'normal',

    };
    if (item.class == 'highlight') {
      let color = this.get_color_from_probability(item);
      style = {
        'background-color': color, 
        'display' : 'inline-block',
        'width': '15px',
        'margin-left': '5px',
        'text-align': 'center', 
        'font-weight' : 'bold',

      };
    }
    return style;
  }

  get_color_from_probability(item){
    if (item && item.tooltip)
    {
      // Extract probabilities from format like "Phosphothreonine:0.61;O-linked_glycosylation:0.535"
      const probabilities = [];
      const tooltipStr = item.tooltip;
      
      if (tooltipStr && typeof tooltipStr === 'string') {
        const parts = tooltipStr.split(';');
        parts.forEach(part => {
          if (part && part.includes(':')) {
            const probability = parseFloat(part.split(':')[1]);
            if (!isNaN(probability)) {
              probabilities.push(probability);
            }
          }
        });
      }

      // console.log('probabilities: ', probabilities);

      if (probabilities.length > 0 && probabilities.some(number => number > this.sliderValue)) {
        let maxNumber = Math.max(...probabilities);
        
        let red = 255;
        let green = 255 - (maxNumber*255); 
        let string = 'rgb(' + red + ', ' + green + ', ' + '0' + ')';
        // let string = 'rgb(' + red + ', ' + green + ', ' + green + ')';
    
        return string;    
      } 
      else {
        return 'transparent';
      }
    }
    else {
      return 'transparent';
    }
  }
}
